<template>
  <div class="setComponent">
    <el-table
      size="medium"
      :data="tableData"
      style="width: 100%">
      <!--<el-table-column-->
        <!--type="selection"-->
        <!--width="45">-->
      <!--</el-table-column>-->
      <el-table-column :label="$i18n.t('wm_lang_6b0bc6')">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <span>{{ scope.row.operateEmail || '-' }}</span>
            <div slot="reference" class="cutout">{{ scope.row.operateEmail || '-' }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_7e951d')">
      <template slot-scope="scope">
        <span>{{ ($moment(scope.row.operateTime).format('YYYY-MM-DD HH:mm:ss')) || '-' }}</span>
      </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_2b6bc0')+' IP'">
        <template slot-scope="scope">
          <span>{{ scope.row.operateIp || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_2f2786')" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.operateContent }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_870802')" width="100px">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <span>{{ scope.row.ruleName }}</span>
            <div slot="reference" class="cutout">{{ scope.row.ruleName }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column width="100" :label="$i18n.t('wm_lang_a85cce')">
        <template slot-scope="scope">
          <span>{{ scope.row.ruleStatus === 1 ? $i18n.t('wm_lang_7854b5') : $i18n.t('wm_lang_710ad0') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_65939c')">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <span>{{ scope.row.touchCondition }}</span>
            <div slot="reference" class="cutout">{{ scope.row.touchCondition }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column :label="$i18n.t('wm_lang_d1d904')">
        <template slot-scope="scope">
          <el-popover
            placement="top-end"
            width="200"
            trigger="hover">
            <span>{{ scope.row.executeAction }}</span>
            <div slot="reference" class="cutout">{{ scope.row.executeAction }}</div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="page_block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <el-button type="primary" @click="cancelForm">{{$t("wm_lang_html_5f4112")}}</el-button>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
export default {
  name: 'rulesLog',
  data () {
    return {
      // 表格
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 1
    }
  },
  mounted() {
    this.getLogList({limit: 10, page: 1});
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.getLogList({limit: 10, page: val});
    },
    cancelForm() {
      this.$router.push({name: 'classificationRules'});
    },
    getOperateContent(operateContent) {
      let cont = '';
      switch (operateContent) {
        case xmail.enums.FilterOperateType.ADD_RULE:
          cont = this.$i18n.t('custom_lang_0091');
          break;
        case xmail.enums.FilterOperateType.UPDATE_RULE:
          cont = this.$i18n.t('custom_lang_0092');
          break;
        case xmail.enums.FilterOperateType.DEL_RULE:
          cont = this.$i18n.t('custom_lang_0093');
          break;
        case xmail.enums.FilterOperateType.UP_RULE:
          cont = this.$i18n.t('custom_lang_0094');
          break;
        case xmail.enums.FilterOperateType.DOWN_RULE:
          cont = this.$i18n.t('custom_lang_0095');
          break;
        case xmail.enums.FilterOperateType.ENABLE:
          cont = this.$i18n.t('wm_lang_7854b5');
          break;
        case xmail.enums.FilterOperateType.DISABLE:
          cont = this.$i18n.t('wm_lang_710ad0');
          break;
        case xmail.enums.FilterOperateType.UNKNOWN:
          cont = this.$i18n.t('custom_lang_0090');
          break;
      }
      return cont;
    },
    getLogList(opts) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Filter.getFilterLogByPageParamBuilder();
        pm.limit = opts.limit;
        pm.page = opts.page;
        api.Filter.getFilterLogByPage(pm, function (res) {
          console.log(res.data);
          if(res.data.code === 0) {
            if(Object.keys(res.data.data).length === 0) {
              return;
            }
            self.tableData = res.data.data.records;
            self.currentPage = res.data.data.current;
            self.total = res.data.data.total;
            self.pageSize = res.data.data.size;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
 .page_block{ text-align: right; margin:20px 0 0 0 }
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/rulesLog.vue